<template lang="pug">
  .component-backoffice-driver-license-approval-list.row.column
    .row
      .column
        SearchEntity(entity="drivers", v-model="search.driver_id")
      .column
        SelectizeDocumentType(@optionSelected="selectType", @optionRemoved="unsetType")
    BaseList(
      :component="component",
      :dataLoader="dataLoader",
      :search="search",
      componentType="license-approval-list")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'
  import SelectizeDocumentType from '../../components/structure/ui/lists/selectize/SelectizeDocumentType'
  import SelectizeDriver from '../../components/structure/ui/lists/selectize/SelectizeDriver'
  import SearchEntity from "../../components/structure/ui/SearchEntity.vue";

  export default {
    name: 'DriverLicenseApprovalQueue',
    components: {
      SearchEntity,
      SelectizeDriver,
      SelectizeDocumentType,
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/DriverLicence.vue'),
        test: [],
        search: {
          driver_id: null,
          document_type_id: null,
        }
      }
    },
    methods: {
      unsetType() {
        this.search.document_type_id = null
      },
      selectType(obj) {
        this.search.document_type_id = obj.id
      },
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.driverLicenses.list(page, resultsPerPage, search).approval((data) => {
          this.test = data
          callback(data)
        })
      },
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-driver-license-approval-list
    .filters
      display: flex
      flex-direction: row
      justify-content: space-evenly
</style>



// WEBPACK FOOTER //
// DriverLicenseApprovalQueue.vue?07ac160e